document.addEventListener("DOMContentLoaded", function() {
    const flashSales = document.querySelectorAll('.flash_sale');

    flashSales.forEach(flashSaleDiv => {
        const startTime = new Date(flashSaleDiv.getAttribute('data-start'));
        const endTime = new Date(flashSaleDiv.getAttribute('data-end'));

        const updateTimer = () => {
            const currentTime = new Date();
            const timeToStart = startTime - currentTime;
            const timeToEnd = endTime - currentTime;
            const timeSinceEnd = currentTime - endTime;

            if (timeToStart > 0) {
                // Countdown before flash sale starts
                const days = Math.floor(timeToStart / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeToStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeToStart % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeToStart % (1000 * 60)) / 1000);

                flashSaleDiv.innerHTML = `<span>Flash sale starts in:</span><span> ${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
            } else if (timeToEnd > 0) {
                // Countdown during flash sale
                const days = Math.floor(timeToEnd / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeToEnd % (1000 * 60)) / 1000);

                flashSaleDiv.innerHTML = `<span>Flash sale ends in:</span><span> ${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
            } else if (timeSinceEnd <= 60 * 60 * 1000) {
                // Flash sale ended less than an hour ago
                flashSaleDiv.innerHTML = '<span>The flash sale has ended.</span>';
            } else {
                // Flash sale ended more than an hour ago, hide the element
                flashSaleDiv.style.display = 'none';
            }
        };

        // Call updateTimer immediately and then every second
        updateTimer(); 
        setInterval(updateTimer, 1000);
    });
});
